import Rellax from 'rellax';

document.querySelectorAll('.rellax').forEach(rellax => new Rellax(rellax));
